import StaticContentPage from "./StaticContentPage";

const TermsAndConditions = () => (
  <StaticContentPage slug="terms-and-condition" title="Terms and Conditions" />
);

export default TermsAndConditions;
